import RouterLink from './RouterLink'

export default RouterLink
